<template>
  <a :href="url" :class="buttonClass" @click="onClick">{{ label }}</a>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api';

type ButtonStyle = 'primary' | 'outline-primary';

export default defineComponent({
  name: 'OCButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: undefined,
    },
    type: {
      type: String as PropType<ButtonStyle>,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    click: () => true,
  },
  setup(props, { emit }) {
    const onClick = (e: Event) => {
      if (props.url == null) e.preventDefault();
      if (props.disabled) return;

      emit('click');
    };

    const buttonClass: Record<string, boolean> = {
      'oc-button': true,
      disabled: props.disabled,
    };
    buttonClass[`oc-button-${props.type}`] = true;

    return {
      onClick,
      buttonClass,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.oc-button {
  display: block;
  background: $oc-primary;
  border-radius: 10px;
  padding: 12px 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  line-height: 24px;
  cursor: pointer;
  &:hover {
    background: $oc-primary-light60;
    text-decoration: none;
  }

  &.oc-button-outline-primary {
    color: $oc-primary;
    background: $oc-white;
    border: 1px solid $oc-primary;

    &:hover,
    &:active {
      background: $oc-area-bg;
    }
    &:disabled,
    &:disabled:hover {
      color: $oc-gray10;
      background: $oc-white;
      border: 1px solid $oc-gray10;
    }
  }

  &.disabled,
  &.disabled:hover {
    background: $oc-gray10;
  }
}
</style>
